import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Access tokens expire after 12h; the httponly refresh cookie (180 days) is what actually
// keeps a device logged in. On a 401 we transparently mint a fresh access token from that
// cookie and retry the original request once — the user never sees a login screen just
// because their token happened to expire mid-session. Concurrent 401s share one in-flight
// refresh instead of firing the endpoint once per failed request.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { config, response } = err;
    const isAuthRoute = config?.url?.includes("/auth/login") || config?.url?.includes("/auth/refresh");
    if (response?.status !== 401 || isAuthRoute || config._retried) {
      return Promise.reject(err);
    }
    config._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      const { data } = await refreshPromise;
      localStorage.setItem("crm_token", data.access_token);
      config.headers.Authorization = `Bearer ${data.access_token}`;
      return api(config);
    } catch (refreshErr) {
      localStorage.removeItem("crm_token");
      return Promise.reject(err);
    }
  }
);

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  const token = localStorage.getItem("crm_token");
  // No token (e.g. an anonymous visitor on a shared /dok/:docId client link) — omit the
  // param entirely rather than sending the literal string "null", which the backend would
  // otherwise try (and fail) to decode as a JWT instead of treating as "no token".
  return token ? `${API}/files/${path}?auth=${token}` : `${API}/files/${path}`;
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Terjadi kesalahan";
}
